import { render, staticRenderFns } from "./promo-resource-tab.vue?vue&type=template&id=7abb4811&scoped=true"
import script from "./promo-resource-tab.vue?vue&type=script&lang=js"
export * from "./promo-resource-tab.vue?vue&type=script&lang=js"
import style0 from "./promo-resource-tab.vue?vue&type=style&index=0&id=7abb4811&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7abb4811",
  null
  
)

export default component.exports